import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await axios.post(`${API}/auth/forgot-password`, { email });
      setSent(true);
    } catch (err) {
      setError(err.response?.data?.detail || 'Error al enviar. Intenta de nuevo.');
    }
    setLoading(false);
  };

  const cardStyle = {
    background: '#10151E',
    border: '1px solid rgba(255,255,255,0.08)',
    borderRadius: '16px',
    padding: '32px 28px',
  };

  const inputStyle = {
    width: '100%', height: '44px', padding: '0 12px',
    background: 'rgba(255,255,255,0.04)',
    border: '1px solid rgba(255,255,255,0.09)',
    borderRadius: '10px', fontSize: '14px', color: '#E2E8F0',
    outline: 'none', boxSizing: 'border-box', transition: 'border-color 0.15s',
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center',
      background: 'radial-gradient(ellipse at 50% 40%, rgba(0,200,120,0.06) 0%, #090C11 55%)',
      padding: '24px',
    }}>
      <motion.div
        initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.35 }}
        style={{ width: '100%', maxWidth: '380px' }}
      >
        <div style={{ marginBottom: '32px', height: '140px', display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden' }}>
          <img src="/nexia-logo.png" alt="Nexia" style={{ height: '185px', width: 'auto', marginTop: '-14px' }} />
        </div>

        <div style={cardStyle}>
          <AnimatePresence mode="wait">
            {!sent ? (
              <motion.div key="form" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
                <p style={{ fontSize: '17px', fontWeight: 700, color: '#E2E8F0', margin: '0 0 4px' }}>
                  Recuperar contraseña
                </p>
                <p style={{ fontSize: '13px', color: '#475569', margin: '0 0 24px' }}>
                  Te enviamos un link a tu correo para crear una nueva.
                </p>

                <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                  <div>
                    <label style={{ display: 'block', fontSize: '11px', fontWeight: 600, color: '#475569', marginBottom: '6px', textTransform: 'uppercase', letterSpacing: '0.06em' }}>
                      Email
                    </label>
                    <input
                      type="email" required value={email}
                      onChange={e => setEmail(e.target.value)}
                      placeholder="correo@empresa.com"
                      style={inputStyle}
                      onFocus={e => e.target.style.borderColor = 'rgba(0,200,120,0.5)'}
                      onBlur={e => e.target.style.borderColor = 'rgba(255,255,255,0.09)'}
                    />
                  </div>

                  <AnimatePresence>
                    {error && (
                      <motion.p initial={{ opacity: 0, y: -4 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0 }}
                        style={{ margin: 0, padding: '10px 14px', background: 'rgba(239,68,68,0.07)', border: '1px solid rgba(239,68,68,0.18)', borderRadius: '10px', fontSize: '13px', color: '#F87171' }}>
                        {error}
                      </motion.p>
                    )}
                  </AnimatePresence>

                  <button type="submit" disabled={loading} style={{
                    width: '100%', height: '44px', borderRadius: '10px',
                    fontSize: '14px', fontWeight: 700, border: 'none',
                    cursor: loading ? 'not-allowed' : 'pointer',
                    background: loading ? '#1A2030' : '#00C878',
                    color: loading ? '#475569' : '#000',
                  }}>
                    {loading ? 'Enviando...' : 'Enviar link'}
                  </button>
                </form>
              </motion.div>
            ) : (
              <motion.div key="sent" initial={{ opacity: 0, scale: 0.97 }} animate={{ opacity: 1, scale: 1 }}
                style={{ textAlign: 'center', padding: '8px 0' }}>
                <div style={{ fontSize: '44px', marginBottom: '16px' }}>📬</div>
                <p style={{ fontSize: '16px', fontWeight: 700, color: '#E2E8F0', margin: '0 0 8px' }}>
                  Revisa tu correo
                </p>
                <p style={{ fontSize: '13px', color: '#475569', margin: '0 0 24px', lineHeight: 1.6 }}>
                  Si <strong style={{ color: '#94A3B8' }}>{email}</strong> está registrado, recibirás un link en los próximos minutos.
                </p>
                <p style={{ fontSize: '12px', color: '#334155' }}>
                  ¿No llegó? Revisa tu carpeta de spam.
                </p>
              </motion.div>
            )}
          </AnimatePresence>
        </div>

        <div style={{ textAlign: 'center', marginTop: '20px' }}>
          <Link to="/login" style={{ fontSize: '13px', color: '#475569', textDecoration: 'none' }}
            onMouseEnter={e => e.target.style.color = '#00C878'}
            onMouseLeave={e => e.target.style.color = '#475569'}>
            ← Volver al inicio de sesión
          </Link>
        </div>
      </motion.div>
    </div>
  );
};

export default ForgotPassword;
